export type StorageType = "local" | "session" | "cookie";

export enum StorageKey {
  UserInfo = "userInfo",
}


export const STORAGE_RULES: Record<
  StorageKey,
  { primary: StorageType; replicas: StorageType[] }
> = {
  [StorageKey.UserInfo]: {
    primary: "cookie",
    replicas: ["session"],
  }
};
